import { render, staticRenderFns } from "./toDeal.vue?vue&type=template&id=f474ecac&scoped=true&lang=pug"
import script from "./toDeal.vue?vue&type=script&lang=js"
export * from "./toDeal.vue?vue&type=script&lang=js"
import style0 from "./toDeal.vue?vue&type=style&index=0&id=f474ecac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f474ecac",
  null
  
)

export default component.exports